<template>
  <div class="list">
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <!--Start Linke Seite/Filter-->
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
              :disabled="listTab === 2"
            ></head-menu-filter>
            <div class="row">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['name']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.surname') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['vorname']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.firstname') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.status"
                        :options="aktivitaetsstati"
                        :reduce="(s) => s.id"
                        label="bezeichnung"
                        :placeholder="$t('global.status')"
                        multiple
                      >
                        <span slot="no-options">
                          {{ $t('global.nostatusfound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.status') }}</label>
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  v-show="!rolleProp"
                >
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-if="rollen"
                        v-model="filters.rolle"
                        :reduce="(r) => r.id"
                        :options="rollen"
                        label="bezeichnung"
                        :placeholder="$t('global.type')"
                        multiple
                      >
                        <span slot="no-options">
                          {{ $t('global.notypefound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.type') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['funktion']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.function') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['viaFirma']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.company') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['korrAddress']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.address') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters['kanton']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.canton') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.korrespondenzsprache"
                        :options="sprachen"
                        :reduce="(s) => s.id"
                        label="bezeichnung"
                        :placeholder="$t('global.language')"
                        multiple
                      >
                        <span slot="no-options">
                          {{ $t('global.nolanguagefound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.language') }}</label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="$CONST('CONFIG').APPTYPE != 'DESKA'"
                  class="row"
                >
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.konkordat"
                        :reduce="(i) => i.id"
                        :options="konkordate"
                        label="bezeichnung"
                        :placeholder="$t('global.concordat')"
                        multiple
                      >
                        <span slot="no-options">
                          {{ $t('global.nointerestfound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.concordat') }}</label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="$CONST('CONFIG').APPTYPE === 'Education'"
                  class="row"
                >
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.funktionsbereich"
                        :reduce="(fb) => fb.id"
                        :options="funktionsbereiche"
                        label="bezeichnung"
                        :placeholder="$t('global.functionalarea')"
                        multiple
                      >
                        <span slot="no-options">
                          {{ $t('global.nofunctionalareafound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.functionalarea') }}</label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="$CONST('CONFIG').APPTYPE != 'DESKA'"
                  class="row"
                >
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.interesse"
                        :reduce="(i) => i.id"
                        :options="interessen"
                        label="bezeichnung"
                        :placeholder="$t('global.interests')"
                        multiple
                      >
                        <span slot="no-options">
                          {{ $t('global.nointerestfound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.interests') }}</label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="$CONST('CONFIG').APPTYPE != 'DESKA'"
                  class="row"
                >
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.versand"
                        multiple
                        :reduce="(vl) => vl.id"
                        :options="versandlisten"
                        label="bezeichnung"
                        :placeholder="$t('global.dispatch')"
                      >
                        <span slot="no-options">
                          {{ $t('global.nomailinglistfound') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.mailinglist') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <single-select-lehrgang
                      id="gpliste-lehrgang-select"
                      :label="$t('global.educationcourse')"
                      :lehrgang="filters.course"
                      :allowOpen="false"
                      editable
                      @confirmed="setFilterLehrgang"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <single-select-veranstaltung
                      id="gpliste-veranstaltung-select"
                      :label="$t('global.event')"
                      :veranstaltung="filters.veranstaltung"
                      :allowOpen="false"
                      editable
                      @confirmed="setFilterVeranstaltung"
                    />
                  </div>
                </div>
                <div
                  v-if="$CONST('CONFIG').APPTYPE != 'DESKA'"
                  class="row"
                >
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.institution"
                        multiple
                        :reduce="(i) => i.id"
                        :options="institutionen"
                        :getOptionLabel="(i) => i.bezeichnung"
                        :placeholder="$t('global.institution')"
                      >
                        <span slot="no-options">
                          {{ $t('global.taptosearch') }}
                        </span>
                      </v-select>
                      <label>{{ $t('global.institution') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12 my-2">
                    <div
                      class="form-group-inline"
                      style="margin-left: 7px"
                    >
                      <label
                        class="float-left"
                        style="
                          font-size: 11px !important;
                          font-weight: 700 !important;
                        "
                      >
                        {{ $t('global.no_communication_adress') }}
                      </label>
                      <input
                        class="form-check-input float-right mx-3"
                        style="margin-top: 0.2rem"
                        v-model="filters['keine_kommunikationsadresse']"
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div
                      class="form-group"
                      id="number-of-records"
                    >
                      <input
                        v-model="filters.count"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.numberofrecords') }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button
                  @searchWithFilter="filterSearch"
                  @resetFilter="clearFilter"
                  :disabled="listTab === 2"
                />
                <!--Oder Statement switch-->
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <button
                        class="btn btn-secondary"
                        @click="toggleOrParameter"
                        :disabled="listTab === 2"
                        :title="
                          listTab === 2 ? $t('global.pleasechangethetab') : ''
                        "
                      >
                        {{
                          filters.orStatement
                            ? $t('global.orfilteractive')
                            : $t('global.orfilterinactive')
                        }}
                      </button>
                    </div>
                  </div>
                </div>
                <!--Ende Oder Statement switch-->
              </div>
            </div>
          </div>
        </div>
        <!--Ende Linke Seite/Filter-->

        <!--Start RechteSeite-->
        <!--Start Headline/Buttonbar-->
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="
                rolleProp && rolleObj
                  ? rolleObj.bezeichnung
                  : $t('global.personlist')
              "
              :date="'Mittwoch 29.Juli'"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row d-flex justify-content-between px-4 flex-wrap">
                  <router-link
                    v-if="
                      rolleProp && berechtigungen.m_geschaeftspartner.create
                    "
                    class="btn btn-primary mr-2 mb-1"
                    :to="{
                      name: 'NeuerGeschäftspartnerMitRolle',
                      params: { rolleProp: rolleProp },
                    }"
                  >
                    <font-awesome-icon icon="fa-regular fa-plus" />
                    {{
                      rolleProp && rolleObj
                        ? rolleObj.bezeichnung
                        : $t('global.businesspartner')
                    }}
                    {{ $t('global.add') }}
                  </router-link>
                  <router-link
                    v-if="
                      !rolleProp && berechtigungen.m_geschaeftspartner.create
                    "
                    class="btn btn-success mr-2 mb-1"
                    :to="{
                      name: 'geschaeftspartner',
                      params: { anzeige: 0 },
                    }"
                  >
                    <font-awesome-icon icon="fa-regular fa-plus" />
                    {{ $t('global.new') }}
                  </router-link>

                  <span>
                    <b-dropdown variant="primary mr-2 mb-1">
                      <template slot="button-content">
                        <font-awesome-icon
                          icon="fa-duotone fa-print"
                          class="mr-2"
                        />
                        {{ $t('global.print') }}
                      </template>
                      <b-dropdown-item @click="druckeTischkarten">
                        {{ $t('global.placecards') }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="druckeAdressEtiketten">
                        {{ $t('global.addresslabels') }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="druckeNamensschilder">
                        {{ $t('global.nametags') }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                  <div
                    style="display: inline-flex"
                    class="mr-2 mb-1"
                  >
                    <massenmutation-button
                      :propEntities="propEntities"
                      @mutated="refresh"
                      :selectedIds="this.selectedIds"
                    />
                  </div>

                  <b-dropdown
                    variant="primary mr-2 mb-1"
                    v-if="berechtigungen.m_korrespondenz.update"
                  >
                    <template slot="button-content">
                      <font-awesome-icon
                        icon="fa-regular fa-envelope"
                        class="mr-2"
                      />
                      {{ $t('global.createmassmail') }}
                    </template>
                    <b-dropdown-item @click="massenmailErstellen(true)">
                      {{ $t('global.selected') }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="massenmailErstellen(false)">
                      {{ $t('global.alldisplayed') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      :disabled="selectedIds.length < 1"
                      @click="openSurveymodal"
                    >
                      <font-awesome-icon
                        icon="fa-light fa-clipboard-question"
                        class="mr-2"
                      />
                      {{ $t('global.sendsurvey') }}
                    </b-dropdown-item>
                  </b-dropdown>

                  <b-dropdown
                    variant="primary mr-2 mb-1"
                    v-if="berechtigungen.m_korrespondenz.update"
                  >
                    <template slot="button-content">
                      <font-awesome-icon
                        icon="fa-regular fa-envelope"
                        class="mr-2"
                      />
                      {{ $t('global.createserialletter') }}
                    </template>
                    <b-dropdown-item
                      @click="massenkorrespondenzErstellen(true)"
                    >
                      {{ $t('global.selected') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="massenkorrespondenzErstellen(false)"
                    >
                      {{ $t('global.alldisplayed') }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <div class="mr-2">
                    <b-dropdown variant="primary">
                      <template slot="button-content">
                        <font-awesome-icon
                          icon="fa-regular fa-cog"
                          class="mr-2"
                        />
                        <em>{{ $t('global.actions') }}</em>
                      </template>
                      <b-dropdown-item
                        @click="exportToExcel(listData, 'personen')"
                      >
                        <span class="mr-2">
                          <font-awesome-icon
                            icon="fa-regular fa-file-spreadsheet"
                          />
                        </span>
                        {{ $t('global.export') }}
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-tooltip.hover
                        :title="$t('global.pleaseselectentries')"
                        :disabled="selectedIds.length === 0"
                        @click="exportEinfach"
                      >
                        <span class="mr-2">
                          <font-awesome-icon
                            icon="fa-regular fa-file-spreadsheet"
                          />
                        </span>
                        Export einfach
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="berechtigungen.m_geschaeftspartner.create"
                        v-tooltip.hover
                        :title="
                          $t('global.createportalaccountsforselectedentries')
                        "
                        :disabled="this.selectedIds.length === 0"
                        @click="erstellePortalzugaenge"
                      >
                        <font-awesome-icon
                          icon="fa-duotone fa-globe"
                          class="mr-2"
                        />
                        {{ $t('global.createportalaccess') }}
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="berechtigungen.m_geschaeftspartner.create"
                        @click="oeffneDublettenCheckModal"
                      >
                        <font-awesome-icon
                          icon="fa-duotone fa-user-group"
                          class="mr-2"
                        />
                        {{ $t('global.duplicatecheck') }}
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="
                          berechtigungen.m_geschaeftspartner.create &&
                          isEmergencyMode
                        "
                        @click="oeffneStatisktikLernendeModal"
                      >
                        <font-awesome-icon
                          icon="fa-duotone fa-user-group"
                          class="mr-2"
                        />
                        Lernenden Statistik AG
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>

                  <!-- <button
                    class="btn btn-primary mr-2 mb-1"
                    v-if="berechtigungen.m_geschaeftspartner.create"
                    v-tooltip.hover
                    :title="$t('global.pleaseselectentries')"
                    :disabled="this.selectedIds.length === 0"
                    @click="oeffnePortalZugangErstellenModal"
                  >
                    <font-awesome-icon
                      icon="fa-duotone fa-globe"
                      class="mr-2"
                    />{{ $t("global.createportalaccess") }}
                  </button> -->

                  <button
                    class="btn btn-danger ml-auto"
                    v-if="berechtigungen.m_geschaeftspartner.delete"
                    @click="oeffneLoeschenModal"
                  >
                    <font-awesome-icon icon="fa-duotone fa-trash" />
                    <!-- {{ $t("global.delete") }} -->
                  </button>
                </div>
              </div>
            </div>
            <!--Ende Headline/Buttonbar-->

            <!--Start Liste-->

            <!-- Start Reiter Liste / Selected -->
            <div class="reiterrow row d-flex">
              <div
                class="listenreiter"
                :class="{ active: listTab === 1 }"
                @click="handleTabChange(1)"
                v-tooltip.hover
                :title="$t('global.foundentries')"
              >
                <font-awesome-icon
                  v-if="listTab === 1"
                  icon="fa-solid fa-list"
                />
                <font-awesome-icon
                  v-if="listTab === 2"
                  icon="fa-light fa-list"
                />
              </div>
              <div
                class="listenreiter"
                :class="{
                  active: listTab === 2,
                  disabled: selectedIds.length === 0,
                }"
                @click="handleTabChange(2)"
                v-tooltip.hover
                :title="
                  $t('global.selectedentries') + ': ' + selectedIds.length
                "
              >
                <font-awesome-icon
                  v-if="listTab === 2"
                  icon="fa-solid fa-check-square"
                />
                <font-awesome-icon
                  v-if="listTab === 1"
                  icon="fa-light fa-check-square"
                />
                &nbsp;
                <span>
                  {{ selectedIds.length > 0 ? selectedIds.length : '' }}
                </span>
              </div>
            </div>
            <!-- End Reiter Liste / Selected -->
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listTab === 1 ? listData : selectedObjects"
                    :fields="fields"
                    fixed
                    hover
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template
                      slot="top-row"
                      slot-scope="{ fields }"
                      v-if="listTab === 1"
                    >
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <div class="form-group p-0 m-0">
                          <input
                            class="form-control"
                            v-if="
                              field.key != 'selected' &&
                              field.searchable != false
                            "
                            size="sm"
                            type="text"
                            v-model="filters[field.key]"
                            :placeholder="field.label"
                            autocomplete="off"
                          />
                        </div>
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        :checked="header.selected"
                        @change="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        :checked="row.item.selected"
                        @change="onRowSelected(row)"
                        :key="row.item.id + '-' + row.item.selected"
                      ></b-form-checkbox>
                    </template>
                  </b-table>
                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="infiniteHandler"
                  >
                    <div slot="spinner">
                      {{ $t('global.loadmorebusinesspartners') }}
                    </div>
                    <div slot="no-more">
                      {{ $t('global.nofurtherbusinesspartners') }}
                    </div>
                    <div slot="no-results">
                      {{ $t('global.nofurtherbusinesspartnersfound') }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
            <!--Ende Liste-->
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="geschaeftspartner-loeschen-modal"
      :selectedIds="selectedIds"
      :multiple="true"
      @confirmed="geschaeftspartnerLoeschen"
    />

    <pdf-layer
      id="pdf-layer"
      ref="pdfLayer"
      :src="{
        url: pdfPath,
        withCredentials: true,
      }"
    ></pdf-layer>

    <loading-overlay v-show="loading"></loading-overlay>

    <messagebox-count
      :headerText="$t('global.personsdeleted')"
      id="count-delete-alert-msgbox"
      :ok="true"
      :cancel="false"
      :okText="$t('global.ok')"
      :cancelText="$t('global.cancel')"
    />

    <messagebox-enhanced
      :headerText="$t('global.portalinvitation')"
      id="portalinvitation-alert-msgbox"
      :ok="true"
      :cancel="false"
      :okText="$t('global.ok')"
      @ok="clearPortalzugangResponse"
    >
      <div v-if="portalzugangResponse">
        <div
          v-for="(message, index) in portalzugangResponse.success"
          :key="index"
          class="mb-2"
        >
          <div>Success:</div>
          <p>- {{ message }}</p>
        </div>
        <div
          v-for="(message, index) in portalzugangResponse.errors"
          :key="index"
          class="mb-2"
        >
          <div>Errors:</div>
          <p>- {{ message }}</p>
        </div>
      </div>
    </messagebox-enhanced>

    <!-- <portal-zugang-erstellen-messagebox
      :id="'portal-zugang-erstellen-msgbox'"
      :ok="true"
      :cancel="true"
      :okText="portalZugangOkText"
      :cancelText="$t('global.cancel')"
      @ok="createPortalZugang"
    />

    <portal-zugang-success-messagebox
      :id="'portal-zugang-success-msgbox'"
      :ok="true"
      :cancel="false"
    /> -->

    <dubletten-check-modal id="dubletten-check-modal" />
    <dubletten-zusammenfuehren-modal
      id="dubletten-zusammenfuehren-modal"
      :selectedIds="selectedIds"
    />
    <statistik-lernende-modal id="statistik-lernende-modal" />
    <umfrage-versenden-modal
      :id="'umfrage-versenden-modal'"
      :headerText="$t('global.sendsurvey')"
      :okText="$t('global.apply')"
      :ids="selectedIds"
    />
  </div>
</template>

<script>
  import Api from '@/api/Api'
  //import PortalApi from "@/PortalApi";
  import App from '@/api/AppApi'
  import CarboneApi from '@/api/CarboneApi'
  import FileDownload from 'js-file-download'

  import HeadMenu from '@/components/HeadMenu'
  import HeadMenuFilter from '@/components/HeadMenuFilter'
  import Navbar from '@/components/Navbar'
  import LoeschenModal from '@/components/Modals/LoeschenModal'
  import FilterSearchResetButton from '@/components/Buttons/FilterSearchResetButton'
  import excelExport from '@/mixins/ExcelExport'

  import MessageboxEnhanced from '@/components/Modals/MessageboxEnhanced.vue'
  //import PortalZugangErstellenMessagebox from "@/components/Modals/MessageboxEnhanced.vue";
  //import PortalZugangSuccessMessagebox from "@/components/Modals/MessageboxEnhanced.vue";
  import MassenmutationButton from '@/components/Buttons/MassenmutationButton'

  import store from '@/store'
  import server from '@/server'
  import { LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER } from '@/store/geschaeftspartner/actions.type'
  import { LADE_VERSANDLISTEN } from '@/store/korrespondenz/actions.type'
  import page from '@/mixins/Page'
  import dashboard from '@/mixins/Dashboard'
  import filterNew from '@/mixins/FilterNew'
  import { addresseToSingleLineString } from '@/models/Adresse'
  import DublettenCheckModal from '@/components/crm/DublettenCheckModal.vue'
  import DublettenZusammenfuehrenModal from '@/components/crm/DublettenZusammenfuehrenModal.vue'
  import { LADE_AUSWAHLWERTE_EINSTELLUNGEN } from '@/store/einstellungendashboard/actions.type'
  import SingleSelectLehrgang from '@/components/global/SingleSelectLehrgang.vue'
  import SingleSelectVeranstaltung from '@/components/global/SingleSelectVeranstaltung.vue'
  import UmfrageVersendenModal from '@/components/Modals/UmfrageVersendenModal'
  import StatistikLernendeModal from '@/components/Modals/StatistikLernendeModal.vue'

  export default {
    name: 'personen-liste',
    components: {
      Navbar,
      LoeschenModal,
      HeadMenu,
      HeadMenuFilter,
      MessageboxEnhanced,
      MassenmutationButton,
      FilterSearchResetButton,
      DublettenCheckModal,
      DublettenZusammenfuehrenModal,
      SingleSelectLehrgang,
      SingleSelectVeranstaltung,
      UmfrageVersendenModal,
      StatistikLernendeModal,
      //PortalZugangErstellenMessagebox,
      //PortalZugangSuccessMessagebox,
    },
    metaInfo() {
      const rolleObj = this.rolleObj

      return {
        titleTemplate: () => {
          return rolleObj
            ? 'BX: ' + rolleObj.bezeichnung
            : 'BX: ' + this.$t('global.persons')
        },
      }
    },
    mixins: [page, dashboard, excelExport, filterNew],
    props: {
      rolleProp: {
        type: String,
        required: false,
        default: null,
      },
    },
    store,
    data() {
      return {
        name: 'Geschaeftspartnerliste',
        infiniteId: +new Date(),
        pdfPath: '',
        selected: [],
        selectedIds: [],
        msgboxOkText: this.$t('global.ok'),
        /*portalZugangText: this.$t(
        "global.wouldyouliketosendtheinvitationtoregisteronportal"
      ),
      portalZugangOkText: this.$t("global.createportalaccess"),*/
        firstVisit: true,
        propEntities: [
          {
            tbl_name: 'bxc_geschaeftspartner',
            selectedIds: [],
          },
        ],
        portalzugangResponse: null,
        defaultOnlyActive: this.$CONST('CONFIG').SHOW_ONLY_ACTIVE,
      }
    },
    computed: {
      isEmergencyMode() {
        return window.location.href.includes('emergency')
      },
      fields() {
        return [
          { key: 'selected', label: '' },
          {
            key: 'nummer',
            sortable: true,
            label: 'Nr',
            tdClass: 'col-number',
          },
          {
            key: 'aktivitaetsstatus.bezeichnung',
            sortable: true,
            searchable: false,
            class: 'text-center',
            label: this.$t('global.status'),
          },
          { key: 'name', sortable: true, label: this.$t('global.surname') },
          {
            key: 'vorname',
            sortable: true,
            label: this.$t('global.firstname'),
          },
          {
            key: 'geburtsdatum',
            sortable: true,
            searchable: false,
            label: this.$t('global.dateofbirth'),
          },
          {
            key: 'funktion',
            sortable: true,
            label: this.$t('global.function'),
          },
          {
            key: 'mailadressen[0].bezeichnung',
            sortable: true,
            label: this.$t('global.email'),
          },
          {
            key: 'telefon_g',
            sortable: true,
            label: this.$t('global.phoneb'),
            tdClass: 'minw-130-px',
          },
          {
            key: 'viafirma.name',
            sortable: true,
            searchable: false,
            label: this.$t('global.company'),
          },
          {
            key: 'kommunikationsadresse.adresseKomplett',
            sortable: true,
            searchable: false,
            label: this.$t('global.address'),
          },
        ]
      },
      queryParams: function () {
        var params = {}

        params.nummer = this.setQueryParam(this.filters.nummer)
        params.name = this.setQueryParam(this.filters['name'])
        params.vorname = this.setQueryParam(this.filters['vorname'])
        params.status = this.setQueryParamList(this.filters.status)
        let filterRollen
        if (this.rolleProp) filterRollen = this.rolleProp
        else
          filterRollen = this.filters.rolle
            ? this.filters.rolle.join(',')
            : null

        params.funktion = this.setQueryParam(this.filters['funktion'])
        params.viaFirma = this.setQueryParam(this.filters['viaFirma'])
        params.korrAddress = this.setQueryParam(this.filters['korrAddress'])
        params.kanton = this.setQueryParam(this.filters['kanton'])
        params.telg = this.setQueryParam(this.filters.telefon_g)
        params.rollen = this.setQueryParam(filterRollen)
        params.email = this.setQueryParam(
          this.filters['mailadressen[0].bezeichnung']
        )

        params.korrespondenzsprache = this.setQueryParamList(
          this.filters['korrespondenzsprache']
        )
        params.interesse = this.setQueryParamList(this.filters.interesse)
        params.konkordat = this.setQueryParamList(this.filters.konkordat)
        params.fbereich = this.setQueryParamList(this.filters.funktionsbereich)
        params.versand = this.setQueryParamList(this.filters.versand)
        params.course = this.setQueryParam(this.filters.course?.id)
        params.veranstaltung = this.setQueryParam(this.filters.veranstaltung?.id)
        params.institution = this.setQueryParamList(this.filters.institution)
        params.keine_kommunikationsadresse = this.setQueryParam(
          this.filters['keine_kommunikationsadresse']
        )

        params.filterCount = this.setQueryParam(this.filters.count)
        params.orStatement = this.setQueryParam(
          this.filters.orStatement ? 'true' : undefined
        )
        params.typ = '17EF8844E6B'
        params.incf = '1'

        return params
      },

      sprachen: {
        get() {
          return this.$store.state.einstellungendashboard.sprachen
        },
      },

      rollen: {
        get() {
          return this.$store.state.geschaeftspartner.partnerrollen
        },
      },
      funktionsbereiche: {
        get() {
          return this.$store.state.geschaeftspartner.funktionsbereiche
        },
      },
      interessen: {
        get() {
          return this.$store.state.geschaeftspartner.interessen
        },
      },
      aktivitaetsstati: {
        get() {
          return this.$store.state.geschaeftspartner.aktivitaetsstati
        },
      },
      versandlisten: {
        get() {
          return this.$store.state.korrespondenz.versandlisten
        },
      },
      konkordate: {
        get() {
          return this.$store.state.geschaeftspartner.konkordate
        },
      },
      institutionen: {
        get() {
          return this.$store.state.geschaeftspartner.institutionen
        },
      },

      rolleObj() {
        if (this.rolleProp && this.rollen)
          return this.rollen.find((r) => r.id === this.rolleProp)
        return null
      },
      headline() {
        if (this.rolleProp && this.rollen) {
          let rolle = this.rollen.find((r) => r.id === this.rolleProp)
          if (rolle) return rolle.bezeichnung
        }
        return 'BX: ' + this.$t('global.contacts')
      },
    },
    watch: {},
    created() {
      if (this.rollen.length == 0)
        this.$store.dispatch(
          `geschaeftspartner/${LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER}`
        )

      if (this.versandlisten.length == 0)
        this.$store.dispatch(`korrespondenz/${LADE_VERSANDLISTEN}`)

      this.initFilter('geschaeftspartner-liste', 'geschaeftspartner/', true)
    },
    mounted() {
      if (this.sprachen.length == 0) {
        this.$store.dispatch(
          `einstellungendashboard/${LADE_AUSWAHLWERTE_EINSTELLUNGEN}`
        )
      }

      if (!this.filters.status && this.firstVisit) {
        if (this.defaultOnlyActive === '1') {
          // Wenn die Konfiguration auf "nur aktive anzeigen" steht, setzen wir den Filter auf "Aktiv"
          this.$set(this.filters, 'status', ['1737FA777AA'])
        } else {
          // Ansonsten lassen wir den Status-Filter leer, um alle Einträge anzuzeigen
          this.$set(this.filters, 'status', [])
        }
        this.firstVisit = false // Markieren, dass der erste Besuch abgeschlossen ist
      }

      this.$bus.$emit('searchWithFilter')
      //TODO: Mandantenspezifisches FrontEnd sauber loesen
      if (location.href.includes('healthspot')) {
        this.showLoginErstellenButton = true
      }
    },
    methods: {
      adresse(geschaeftspartner) {
        if (geschaeftspartner.hauptadresse)
          return addresseToSingleLineString(geschaeftspartner.hauptadresse)
        else return ''
      },
      toggleOrParameter() {
        if (this.filters.orStatement) {
          this.$set(this.filters, 'orStatement', false)
        } else {
          this.$set(this.filters, 'orStatement', true)
        }
        this.filterSearch()
      },

      geschaeftspartnerLoeschen() {
        this.delete('geschaeftspartner/', this.selectedIds)
      },

      oeffneLoeschenModal() {
        if (this.selectedIds.length > 0) {
          this.$bus.$emit(
            'openLoeschenModal',
            'geschaeftspartner-loeschen-modal'
          )
        } else {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nopersonsselected'),
          })
        }
      },

      // oeffneLoginErstellenModal() {
      //   if (this.selectedIds.length > 0) {
      //     this.msgboxOkText = `${this.$t("global.ok")} (${
      //       this.selectedIds.length
      //     })`;
      //     let text = this.$t("global.createLoginInquiry");

      //     this.$bus.$emit("openMessageBoxEnhanced", {
      //       id: "create-login-alert-msgbox",
      //       text: text,
      //     });
      //   }
      // },

      ausgebenAvery365221() {
        let ids = this.selectedIds.join(',')
        let filename = new Intl.DateTimeFormat('ch').format(new Date())

        this.pdfPath =
          server.url +
          `/pdfgenerator/pdf.act?filename=AV${filename}.pdf&report=/pdfgenerator/avery-3652-21.htm&ids=${ids}`
        this.$refs.pdfLayer.show()
      },

      ausgebenAvery365314() {
        let ids = this.selectedIds.join(',')
        let filename = new Intl.DateTimeFormat('ch').format(new Date())

        this.pdfPath =
          server.url +
          `/pdfgenerator/pdf.act?filename=AV${filename}.pdf&report=/pdfgenerator/avery-3653-14.htm&ids=${ids}`
        this.$refs.pdfLayer.show()
      },

      ausgebenZweckform478427() {
        let ids = this.selectedIds.join(',')
        let filename = new Intl.DateTimeFormat('ch').format(new Date())

        this.pdfPath =
          server.url +
          `/pdfgenerator/pdf.act?filename=AV${filename}.pdf&report=/pdfgenerator/zweckform-4784-27.htm&ids=${ids}`
        this.$refs.pdfLayer.show()
      },

      massenmailErstellen(selected) {
        if (!selected || this.selectedIds.length > 0) {
          let tempList = selected
            ? this.selectedIds
            : this.$refs.selectableTable.items.map((item) => item.id)

          let json = {
            empfaenger: tempList,
            isMassMail: true,
            inhalt: '',
            zeitpunkt: new Intl.DateTimeFormat('ch').format(new Date()),
          }

          Api.post('mail/', json, { params: {} }).then((response) => {
            this.$router.push({
              name: 'mail',
              params: {
                id: response.data.id,
                anzeige: 0,
              },
            })
          })
        } else
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nopersonsselected'),
          })
      },

      massenkorrespondenzErstellen(selected) {
        if (!selected || this.selectedIds.length > 0) {
          let tempList = selected
            ? this.selectedIds
            : this.$refs.selectableTable.items.map((item) => item.id)

          let json = {
            empfaenger: [],
            person: [], // ist de facto person. Noch unsauber im Backend
            isMassKorrespondenz: true,
            versand: {
              erstelltvon: this.angemeldeterMitarbeiter.person,
              datum: new Intl.DateTimeFormat('ch').format(new Date()),
              ort: this.$CONST('CONFIG').MANDANTSTADT,
              betreff: '',
            },
            inhalt: '',
            zeitpunkt: new Intl.DateTimeFormat('ch').format(new Date()),
          }

          json.empfaenger = tempList
          json.person = tempList

          Api.post('korrespondenz/', json, { params: {} }).then((response) => {
            Api.post('korrespondenz/empfaenger/', json, {
              params: {
                korrespondenz: response.data.id,
                isPerson: true,
                isMassCorr: true,
              },
            }).then(() => {
              this.$router.push({
                name: 'korrespondenz',
                params: {
                  id: response.data.id,
                  anzeige: 0,
                },
              })
            })
          })
        } else
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nopersonselected'),
          })
      },

      details(geschaeftspartner) {
        this.$router.push({
          name: 'geschaeftspartner',
          params: { id: geschaeftspartner.id, anzeige: 0 },
        })
      },

      refresh() {
        this.resetLoading(this)
      },

      oeffneDublettenCheckModal() {
        this.$bus.$emit('open-modal', 'dubletten-check-modal')
      },
      oeffneDublettenZusammenfuehrenModal() {
        this.$bus.$emit('open-modal', 'dubletten-zusammenfuehren-modal')
      },
      oeffneStatisktikLernendeModal() {
        this.$bus.$emit('openLernendeStatistikModal')
      },
      exportEinfach() {
        if (this.selectedIds.length === 0) return

        this.loading = true

        CarboneApi.post('carbone-personen-export/', {
          personen: this.selectedIds,
        })
          .then((response) => {
            if (!response.data || response.data.length === 0) {
              this.$notify({
                type: 'warn',
                title: this.$t('global.actionfailed'),
                text: this.$t('global.exportfailed'),
              })
              return
            }
            response.data.forEach((file) => {
              this.savePersonenExportFile(file.url, file.name)
            })
          })
          .catch(() => {
            this.$notify({
              type: 'warn',
              title: this.$t('global.actionfailed'),
              text: this.$t('global.exportfailed'),
            })
          })
          .finally(() => {
            this.loading = false
          })
      },
      async savePersonenExportFile(url, fileName) {
        if (!url) return

        const response = await fetch(Api.defaults.defaultURL + url, {
          headers: {
            'Content-Type':
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },
        })

        const file = await response.blob()
        FileDownload(file, (fileName || 'Personen-Export') + '.xlsx')
      },
      /*oeffnePortalZugangErstellenModal() {
      this.$bus.$emit("openMessageBoxEnhanced", {
        id: "portal-zugang-erstellen-msgbox",
        text: this.portalZugangText,
        headerText: this.$t("global.createportalaccess"),
      });
    },*/
      // createPortalZugang() {
      //   //TODO: Genauere Infos angeben, welche Logins nicht geklappt haben (fehlende Mailadresse oder bereits vorhandenes Login)
      //   PortalApi.post("registration/mail/", this.selectedIds).then(
      //     (response) => {
      //       console.log(response);
      //       this.$bus.$emit("openMessageBoxEnhanced", {
      //         id: "portal-zugang-success-msgbox",
      //         text: "Portal-Zugänge erfolgreich erstellt",
      //         headerText: this.$t("global.actionsuccessful"),
      //       });
      //     }
      //   );
      // },
      druckeTischkarten() {
        if (this.selectedIds?.length > 0 && this.selectedIds?.length < 150) {
          let ids = this.selectedIds.join(',')

          let filename = this.$t('global.placecards')

          this.pdfPath =
            server.url +
            `/pdfgenerator/pdf.act?filename=${filename}.pdf&report=/pdfgenerator/tischkarten-pdf.htm&landscape=true&ids=${ids}`
          this.$refs.pdfLayer.show()
        } else if (this.selectedIds?.length > 150) {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.toomanyentriesselected'),
          })
        } else {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nopersonselected'),
          })
        }
      },
      druckeAdressEtiketten() {
        if (this.selectedIds?.length > 0 && this.selectedIds?.length < 150) {
          let ids = this.selectedIds.join(',')

          let filename = this.$t('global.addresslabels')

          this.pdfPath =
            server.url +
            `/pdfgenerator/pdf.act?filename=${filename}.pdf&report=/pdfgenerator/adress-etiketten-pdf.htm&ids=${ids}`
          this.$refs.pdfLayer.show()
        } else if (this.selectedIds?.length > 150) {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.toomanyentriesselected'),
          })
        } else {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nopersonselected'),
          })
        }
      },
      druckeNamensschilder() {
        if (this.selectedIds?.length > 0 && this.selectedIds?.length < 150) {
          let ids = this.selectedIds.join(',')

          let filename = this.$t('global.nametags')

          this.pdfPath =
            server.url +
            `/pdfgenerator/pdf.act?filename=${filename}.pdf&report=/pdfgenerator/namensschilder-pdf.htm&ids=${ids}`
          this.$refs.pdfLayer.show()
        } else if (this.selectedIds?.length > 150) {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.toomanyentriesselected'),
          })
        } else {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nopersonselected'),
          })
        }
      },
      setFilterLehrgang(lehrgang) {
        this.$set(this.filters, 'course', lehrgang)
      },

      setFilterVeranstaltung(veranstaltung) {
        this.$set(this.filters, 'veranstaltung', veranstaltung)
      },

      erstellePortalzugaenge() {
        if (this.selectedIds.length > 0) {
          this.loading = true
          App.post('portal/createaccess/', this.selectedIds)
            .then((response) => {
              // this.$notify({
              //   type: "success",
              //   title: this.$t("global.actionsuccessful"),
              //   text: this.$t("global.portalinvitationcreated"),
              // });

              // erstellte Portalzugänge darstellen
              this.portalzugangResponse = response.data
            })
            .catch((error) => {
              this.$notify({
                type: 'error',
                title: this.$t('global.actionfailed'),
                text: this.$t('global.errorcreatingportalaccess'),
              })
            })
            .finally(() => {
              this.loading = false
              this.$bus.$emit(
                'openMessageBoxEnhanced',
                'portalinvitation-alert-msgbox'
              )
            })
        } else {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.nopersonselected'),
          })
        }
      },
      clearPortalzugangResponse() {
        this.portalzugangResponse = null
      },
      openSurveymodal() {
        this.$bus.$emit('open-modal', 'umfrage-versenden-modal')
      },
    },
  }
</script>

<style></style>
